module.exports = __webpack_public_path__ + "static/media/44_tn.66b19326.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/44_tn.jpg
// module id = 680
// module chunks = 0